import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Linkedin, Youtube } from 'lucide-react';

export default function Footer() {
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <footer className="bg-[#2d3828] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 sm:gap-12">
          <div>
            <p className="font-body text-white/70 text-sm leading-relaxed">
              503-7700 Hurontario Street<br />
              Brampton, ON L6Y 4M3<br />
              Canada
            </p>
            <p className="font-body text-white/70 text-sm mt-4">
              <a href="mailto:hello@carbonetics.ca" className="hover:text-white transition-colors">
                hello@carbonetics.ca
              </a>
            </p>
          </div>

          <div className="md:text-right">
            <p className="font-body text-white/40 text-xs uppercase tracking-widest mb-4">Company</p>
            <div className="flex flex-wrap md:justify-end gap-4 sm:gap-6">
              {[
                { label: 'Home', to: '/' },
                { label: 'About', to: '/about' },
                { label: 'Services', to: '/services' },
                { label: 'Team', to: '/team' },
                { label: 'Contact', to: '/contact' },
              ].map((link) => (
                <Link key={link.label} to={link.to}
                  className="font-body text-sm text-white/60 hover:text-white transition-colors">
                  {link.label}
                </Link>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-10 sm:mt-12 pt-6 sm:pt-8">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 sm:gap-0">
            <p className="font-display text-3xl sm:text-4xl font-bold text-white">Carbonetics</p>
            <div className="flex flex-wrap items-center gap-4 sm:gap-6">
              {[
                { icon: Facebook, label: 'Facebook', href: 'https://facebook.com' },
                { icon: Instagram, label: 'Instagram', href: 'https://instagram.com' },
                { icon: Linkedin, label: 'Linkedin', href: 'https://linkedin.com' },
                { icon: Youtube, label: 'Youtube', href: 'https://youtube.com' },
              ].map(({ icon: Icon, label, href }) => (
                <a key={label} href={href} target="_blank" rel="noreferrer"
                  className="flex items-center gap-1.5 text-white/50 hover:text-white transition-colors text-xs sm:text-sm font-body">
                  <Icon size={16} />
                  <span className="hidden sm:inline">{label}</span>
                </a>
              ))}
            </div>
          </div>
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between mt-4 sm:mt-6 gap-2">
            <p className="text-white/40 text-xs font-body">©2025 Carbonetics.ca. All Rights Reserved</p>
            <button onClick={scrollToTop}
              className="text-white/40 hover:text-white text-xs font-body flex items-center gap-1 transition-colors">
              ↑ Back to Top
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}